module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/permission-error-page/permission-error-page.component.css
// module id = ./src/app/components/permission-error-page/permission-error-page.component.css
// module chunks = main